import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Client } from '../../models/client';
import { ClientService } from '../client.service';

@Injectable()
export class ClientDetailInstance {
  client: Client;
  $client: BehaviorSubject<Client> = new BehaviorSubject<Client>(null);

  constructor(private clientService: ClientService) {

  }

  reload() {
    this.init(this.client.id);
  }

  init(id: number) {
    this.clientService.find(id).subscribe(client => {
      this.client = client;
      this.$client.next(client);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/client-detail/client-detail.instance.ts